import {
  configureProductDucks,
  CARD_PRODUCT,
} from 'axp-product-ducks';
import { updateLocale } from '@americanexpress/one-app-ducks';

export const updateProductLocale = ({ locale }) => (dispatch) => dispatch(updateLocale(locale || 'en-US'));

const productTypes = [
  CARD_PRODUCT,
];

const memberProducts = () => {
  configureProductDucks({
    getToState: (state) => state.getIn(['modules', 'axp-manage-bookings-root', 'products']),
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
    onLoadProducts: updateProductLocale,
  });
};

memberProducts();

export default memberProducts;
